const BEST_SCORE_KEY = 'crazy-clock-best';
const TUTORIAL_KEY = 'crazy-clock-tutorial-seen';
const SPEED_SIDE_KEY = 'crazy-clock-speed-side';

export type ButtonSide = 'left' | 'right';

export function readBestScore(): number {
  try {
    const raw = window.localStorage.getItem(BEST_SCORE_KEY);
    const value = raw === null ? 0 : Number(raw);
    return Number.isFinite(value) && value > 0 ? value : 0;
  } catch {
    return 0;
  }
}

export function writeBestScore(score: number): void {
  try {
    window.localStorage.setItem(BEST_SCORE_KEY, String(Math.round(score)));
  } catch {
    return;
  }
}

export function hasSeenTutorial(): boolean {
  try {
    return window.localStorage.getItem(TUTORIAL_KEY) === '1';
  } catch {
    return true;
  }
}

export function markTutorialSeen(): void {
  try {
    window.localStorage.setItem(TUTORIAL_KEY, '1');
  } catch {
    return;
  }
}

export function readSpeedButtonSide(): ButtonSide {
  try {
    return window.localStorage.getItem(SPEED_SIDE_KEY) === 'right' ? 'right' : 'left';
  } catch {
    return 'left';
  }
}

export function writeSpeedButtonSide(side: ButtonSide): void {
  try {
    window.localStorage.setItem(SPEED_SIDE_KEY, side);
  } catch {
    return;
  }
}
